import { SurveyConfirmDialog } from './SurveyConfirmDialog';

export type ActivateSurveyConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
};

export const ActivateSurveyConfirmDialog = ({
  onClose,
  onConfirm,
  loading,
}: ActivateSurveyConfirmDialogProps) => {
  return (
    <SurveyConfirmDialog
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      title='Before Activating this Survey'
      confirmButtonText='Activate'
      confirmButtonColor='primary'
      description='Please double-check that all the information is correct. Once the survey is launched, certain aspects of its configuration, such as response options, cannot be changed.'
    />
  );
};
